<template>
  <div class="step-left" :class="{ show: isShowMenu }">
    <template>
      <div class="step-btn" @click="showMenu">
        待办清单
        <el-image class="step-img" :src="stepImg"></el-image>
      </div>
      <el-steps direction="vertical" :active="active" style="height: 90%">
        <el-step
          v-for="(item, index) in stepList"
          :key="index"
          :title="item.name"
          :status="item.state"
          :class="{
            active: active == index,
            skip: item.is_skip === true,
            cursor: item.state == 'wait' && item.is_skip == false,
          }"
          @click.native="change(index, item.action, item.link_type)"
        >
          <div
            class="step-title"
            :class="{ deadline: item.deadline }"
            slot="title"
          >
            <div class="navName">
              {{ lang === "cn" ? item.name : item.name_en }}
            </div>
            <div
              class="remark"
              v-if="
                item.deadline != '开始' && (item.deadline || item.deadline_en)
              "
            >
              {{ lang === "cn" ? item.deadline : item.deadline_en }}
            </div>
            <div
              class="unread error"
              v-if="
                item.mark == 'information' &&
                item.state == 'wait' &&
                item.is_skip
              "
            >
              {{ lang === "cn" ? "未完成" : "Not Finished" }}
            </div>
            <div
              class="unread review"
              v-if="item.mark == 'information' && item.state == 'process'"
            >
              {{ lang === "cn" ? "审核中" : "In Review" }}
            </div>
            <div
              class="unread error"
              v-if="item.mark == 'information' && item.state == 'error'"
            >
              {{ lang === "cn" ? "未通过" : "Fail" }}
            </div>
            <div class="unread bind" v-if="item.mark == 'attestation'">
              {{ statisData.total }}
            </div>
          </div>
          <span slot="icon">
            <template v-if="item.state == 'finish'">
              <i class="el-icon-check" style="font-weight: bold"></i>
            </template>
            <template v-else-if="item.state == 'process' && active != index">
              <el-image class="process-icon" :src="processIcon"></el-image>
            </template>
            <template
              v-else-if="
                item.state == 'wait' && item.is_skip === true && active != index
              "
            >
              <el-image class="process-icon" :src="skipIcon"></el-image>
            </template>
            <template v-else>
              {{ index + 1 }}
            </template>
          </span>
        </el-step>
      </el-steps>
      <!-- <div class="step-version">V1.0.0</div> -->
    </template>
  </div>
</template>

<script>
import { getmyMenu } from "@/api/api";
export default {
  props: ["active"],
  data() {
    return {
      lang: localStorage.getItem("language"),
      statisData: {
        total: 0,
      },
      stepImg: require("../assets/menu.png"),
      processIcon: require("../assets/icon_status1.png"),
      skipIcon: require("../assets/icon_status4.png"),
      stepList: [],
      isShowMenu: false,
      menu_switch: "",
    };
  },
  mounted() {
    this.getMenu();
  },
  created() {},
  methods: {
    //移动端展示菜单
    showMenu() {
      this.isShowMenu = true;
    },
    getMenu() {
      getmyMenu()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            data.forEach((item) => {
              item.deadline_en = "";
              if (item.deadline) {
                let tempArray = item.deadline.split("/");
                item.deadline = tempArray[0];
                if (tempArray[1] === null || tempArray[1] === undefined) {
                  item.deadline_en = "";
                } else {
                  item.deadline_en = tempArray[1];
                }
              }
            });
            this.stepList = data;
            this.$store.commit("menuStatus", JSON.stringify(data));
            localStorage.setItem("menu", JSON.stringify(data));
            this.getStepList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //  菜单进度
    getStepList() {
      // 进度数组
      let arr = this.stepList;
      arr.forEach((item) => {
        let status = item.action;
        switch (status) {
          case 0:
            //未完成
            // item.is_skip = false;  这行有问题
            status = "wait";
            break;
          case 1:
            //跳过
            status = "wait";
            item.is_skip = true;
            break;
          case 2:
            //已读
            status = "finish";
            break;
          case 3:
            //审核中
            status = "process";
            break;
          case 4:
            //完成
            status = "finish";
            item.is_skip = true;
            break;
          case 5:
            //驳回
            status = "error";
            break;
          default:
            status = "wait";
            break;
        }
        item.state = status;
      });
      this.stepList = arr;
      this.$emit("getMenuClick", this.stepList);
      this.$store.commit("menuStatus", JSON.stringify(this.stepList));
      this.$forceUpdate();
    },

    // 跳转到消息列表
    toMessage() {
      this.$router.push({
        path: "/messageList",
      });
    },
    // 跳转到评奖
    tapdiscussion() {
      this.$router.push({
        name: "discussionindex",
      });
    },
    // 步骤条点击事件
    change(index, action, link_type) {
      if (action == 0) {
        return false;
      }
      let { link_url, id } = this.stepList[index];
      if (link_type == 2) {
        window.open(link_url, "_blank");
      } else if (link_url == "/conference") {
        this.$router.push({
          path: link_url,
          query: {
            id,
          },
        });
      } else {
        this.$router.push({
          path: link_url,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.cypx {
  height: 40px;
  line-height: 40px;
  background: #fc9749;
  border-radius: 4px;
  border: 1px solid #fc9749;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  text-align: center;

  cursor: pointer;
  margin-right: 10px;
}
.wlyy {
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 50px;
  margin-left: 20px;
  cursor: pointer;
}
.step-left {
  width: 230px;
  min-width: 230px;
  height: calc(100vh - 100px);
  padding: 20px 20px 50px 30px;
  box-sizing: border-box;
  position: fixed;
  top: 100px;
  left: 0;
  z-index: 99;
  background: #fff;
  overflow-y: scroll;
  .step-btn {
    display: none;
  }
  .step-version {
    padding-top: 22px;
    text-align: center;
  }
  .step-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 13px;
    padding-right: 9px;
    min-height: 30px;
    position: relative;
    top: -3px;
    transition: all 0.1s;
    .navName {
      font-size: 16px;
      line-height: 30px;
    }
    .unread {
      height: 22px;
      color: #fff;
      padding: 0 5px;
      font-size: 14px;
      line-height: 30px;
      text-align: center;
      border-radius: 11px;
      background: #ff4d4f;
      box-sizing: border-box;
    }
    .review {
      min-width: 54px;
      background: #ffb800;
    }
    .bind {
      color: #999;
      background: none;
    }
  }
  .step-title.deadline {
    display: block;
    .remark {
      color: #999;
      font-size: 12px;
      margin-top: 6px;
      line-height: 12px;
    }
  }
  .step-title:hover {
    // color: #fff;
    position: relative;
    background: #e1f4ed;
    border-radius: 0 38px 38px 0;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -10px;
      width: 10px;
      height: 30px;
      background: url("../assets/nav_bg1.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
  &::-webkit-scrollbar-track-piece {
    background-color: rgba(0, 0, 0, 0.1);
    -webkit-border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(125, 125, 125, 0.3);
    -webkit-border-radius: 6px;
  }
  &::-webkit-scrollbar-thumb:horizontal {
    width: 5px;
    background-color: rgba(125, 125, 125, 0.3);
    -webkit-border-radius: 6px;
  }
}
.el-step {
  margin-bottom: 8px;
}
.el-step.is-vertical {
  cursor: pointer;
  .el-step__main {
    padding-left: 5px;
    .el-step__description {
      padding-left: 15px;
    }
  }
}
.el-step__head.is-wait {
  color: #fff;
  .el-step__icon {
    background: #c0c4cc;
  }
}
.el-step__head.is-process {
  color: #fff;
  border-color: #ffb800;
  .el-step__icon {
    background: #ffb800;
    .process-icon {
      width: 24px;
      height: 24px;
      position: relative;
      top: 1px;
      left: 0px;
    }
  }
}
.el-step__head.is-finish {
  color: #fff;
  border-color: #1ac484;
  .el-step__icon {
    background: #1ac484;
  }
  .el-step__line {
    background: #1ac484;
  }
}
.el-step__title.is-finish {
  color: #303133;
  font-weight: 700;
}
.el-step_.el-step__title.is-process_description.is-finish {
  color: #303133;
}
.el-step__title.is-error {
  color: #303133;
  font-weight: 700;
}
.el-step__head.is-error {
  .el-step__line {
    border-left: 0 none;
    background: transparent;
  }
  .el-step__icon {
    color: #fff;
    background: #ff4d64;
    .el-icon-close {
      font-weight: bold;
    }
  }
}
.active {
  .el-step__head.is-wait .el-step__icon {
    background: #1ac484 !important;
    border-color: #1ac484 !important;
  }
  .el-step__title {
    .step-title {
      color: #fff;
      position: relative;
      border-radius: 0 38px 38px 0;
      background: #1ac484;
    }
    .step-title::before {
      content: "";
      position: absolute;
      top: 0;
      left: -10px;
      width: 10px;
      height: 30px;
      background: url("../assets/nav_bg.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .el-step__head.is-process {
    color: #fff;
    border-color: #1ac484;
    .el-step__icon {
      background: #1ac484;
    }
  }
  .step-title {
    .bind {
      color: #fff;
    }
  }
}

.skip {
  .el-step__head.is-wait .el-step__icon {
    background: #5de6dd;
    border-color: #5de6dd;
    .el-image {
      width: 24px;
      height: 24px;
      top: 1px;
    }
  }
  .el-step__title.is-wait {
    color: #303133;
    font-weight: 500;
  }
}

.el-step__head.is-finish .el-step__line {
  display: none;
}
.el-step__line {
  background: none;
  border-left: 2px dashed #c7c7cc;
  .el-step__line-inner {
    border-width: 0 !important;
  }
}

@media only screen and (max-width: 767px) {
  .el-step.is-vertical {
    left: 12px !important;
  }
  .el-step__title.is-process {
    color: rgba(255, 255, 255, 0.7) !important;
  }
  .step-left {
    left: -152px;
    width: 152px;
    color: #fff !important;
    padding: 20px 15px 20px 0;
    min-width: 152px;
    height: calc(100vh - 201px);
    background: #2c2c2e;
    border-radius: 0px 12px 12px 0px;
    transition: all 0.2s;
    .step-btn {
      display: block;
      width: 101px;
      height: 38px;
      font-size: 13px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 204px;
      left: 0;
      background: #2c2c2e;
      border-radius: 0px 100px 100px 0px;
      .step-img {
        width: 23px;
        // height: 15px;
      }
    }
  }
  .show {
    left: 0;
    .step-btn {
      display: none;
    }
  }
  .active .el-step__title .step-title,
  .active .el-step__title .step-title::before {
    background: transparent;
  }
  .el-step__title {
    font-size: 14px;
  }
  .skip .el-step__title.is-wait,
  .el-step__title.is-finish {
    color: rgba(255, 255, 255, 0.7);
  }
}
</style>
<style>
@media (max-width: 1661px) {
  .step-left .step-title .navName {
    font-size: 14px;
  }
}
</style>
